import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const SERVICE_ID  = "service_hadu6ho";
const TEMPLATE_ID = "template_lkjinas";
const PUBLIC_KEY  = "hLMDmYFWRvYGllcvS";

function Contact({ t }) {
  const f = t.contact.form;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setError(false);

    emailjs.send(SERVICE_ID, TEMPLATE_ID, { ...formData, to_email: "info@powershine.nl" }, PUBLIC_KEY)
      .then(() => {
        setSending(false);
        setSubmitted(true);
      })
      .catch((err) => {
        setSending(false);
        setError(JSON.stringify(err));
      });
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1 className="contact-hero__title">{t.contact.title}</h1>
        <p className="contact-hero__subtitle">{t.contact.subtitle}</p>
      </div>

      <div className="container contact-body">
        <div className="contact-info">
          <h3 className="contact-info__title">{t.contact.info.title}</h3>
          {Object.values(t.contact.info).filter((v) => typeof v === "object" && v.label).map(
            (item, i) => (
              <div className="contact-info__item" key={i}>
                <span className="contact-info__label">{item.label}</span>
                <span className="contact-info__value">{item.value}</span>
              </div>
            )
          )}
          <div className="contact-info__badge">
            <span>PowerShine — Nederland</span>
          </div>
        </div>

        <div className="contact-form-wrap">
          {submitted ? (
            <div className="success-msg">
              <div className="success-msg__icon">✅</div>
              <p>{t.contact.success}</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">{f.name}</label>
                  <input
                    className="form-input"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">{f.email}</label>
                  <input
                    className="form-input"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">{f.phone}</label>
                  <input
                    className="form-input"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">{f.service}</label>
                  <select
                    className="form-input form-select"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    {f.serviceOptions.map((opt, i) => (
                      <option key={i} value={i === 0 ? "" : opt} disabled={i === 0}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">{f.message}</label>
                <textarea
                  className="form-input form-textarea"
                  name="message"
                  rows={5}
                  placeholder={f.messagePlaceholder}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              {error && (
                <p style={{ color: "red", fontSize: "0.9rem", wordBreak: "break-all" }}>
                  Error: {error}
                </p>
              )}

              <button className="btn btn--primary btn--full" type="submit" disabled={sending}>
                {sending ? f.sending : f.submit}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Contact;
